module.exports = __webpack_public_path__ + "media/images/alumni/laci-2a585015f531e3376be7077160f91921.png";